export default __webpack_public_path__ + "static/media/bg3.0700a0bd.jpg";